import isAppleDevice from './isAppleDevice';
/**
 * Returns true if Ctrl or cmd keys were pressed.
 */
export default (event) => {
    if (isAppleDevice) {
        return event.metaKey;
    }
      return event.ctrlKey; // Windows, Linux, UNIX
};